import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { ModalLayout } from '@appbase/templates'
import BoardRead from '@board/components/board/BoardRead.vue'

@Component({
    components: {
        ModalLayout,
        BoardRead,
    },
})
export default class BoardModal extends Vue {
    @Prop({ type: Number, required: true }) boardId!: number
    @Prop({ type: Number, required: true }) articleId!: number
    @Prop({ type: String, required: true }) title!: string
    @Prop({ type: String }) lookahead?: string

    get readParams() {
        const { boardId, articleId, title, lookahead } = this
        return {
            boardId, articleId, title, lookahead
        }
    }

    handleClose() {
        this.closeCurrentModal()
    }
}